import React, { Component, useState, Fragment } from "react";
//import compose from 'recompose/compose';
import { connect } from "react-redux";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { withStyles } from "@material-ui/core/styles";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { apiConstants } from '../../_constants/api.constants';
import { uploadService } from "../../_services/upload.service";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import loader from '../../_assets/Ring-Loading.gif';

import { notificationActions } from "../../_actions";


//-- CSS for Material
const styles = theme => ({
    root: {
        maxWidth: '75%',
        margin: '0 auto',
    },
    paddingBox: {
        padding: theme.spacing(2)
    },
    loaderImg: {
        margin: '0 auto',
        display: 'block',
        width: '100%'

    }
});

class EmailNotifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultData: {},
            validated: { errors: { notification_message: "" } },
        };
    }
    //react props update lifecycle
    componentWillReceiveProps(props){
      if(props.sentUserEmailNotifications !== undefined){
        if(
          props.sentUserEmailNotifications.sentUserEmailNotifications !== undefined &&
          props.sentUserEmailNotifications.sentUserEmailNotifications === true
        ){
          console.log("notfication--------------------------", props.sentUserEmailNotifications.sentUserEmailNotifications);

          const { defaultData } = this.state;
          this.setState({
              defaultData: {
                  ...defaultData,
                  notification_message: ""
              }
          });
        }
      }
    }
    /*
    * Validate form field before saving
    */
    handleValidation() {
        const { siteConstants } = this.props.language;

        const fields = this.state.defaultData;
        let formIsValid = true;

        if (fields.notification_message === undefined || fields.notification_message == "") {
            this.setState({
                validated: {
                    errors: { notification_message: siteConstants.ERR_CAN_NOT_BLANK }
                }
            });
            formIsValid = false;
            return false;
        }

        return formIsValid;
    }

    /*
    *   we are setting the Values
    */
    handleChange = (e) => {
        const { name, value } = e.target;
        const { defaultData } = this.state;
        this.setState({
            defaultData: {
                ...defaultData,
                [name]: value
            }
        });
    };



    handleClose = (e) => {

    }


    emailNotifications = e => {
        e.preventDefault();

        if (this.handleValidation()) {
            let obj = {
                notification_for: this.state.defaultData.notification_for !== undefined ? this.state.defaultData.notification_for : 'All',
                notification_message: this.state.defaultData.notification_message
            };
            this.props.dispatch(notificationActions.sentEmailNotifications(apiConstants.SEND_EMAIL_NOTIFICATIONS, obj));
        }
    };






    closeDialog = () => {
        const { defaultData } = this.state;
    }


    render() {
        const { classes } = this.props;
        const { siteConstants } = this.props.language;

        return (

            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/shopkeeper">{siteConstants.MENU_NOTIFICATIONS}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_EMAIL_NOTIFICATIONS}
                                </li>

                                <li style={{ paddingLeft: "600px" }}>
                                    <a href="/settings" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>
                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <Card className={classes.root}>
                                <form role="form" className="col-md-12 col-xs-12" autoComplete="off" encType="multipart/form-data">
                                    <CardContent>
                                        <div className="row mb-4">
                                            <div className="col-lg-3">
                                                <label>{siteConstants.NOTIFICATION_FOR}</label>
                                            </div>
                                            <div className="col-lg-9">
                                                <select
                                                    className="form-control"
                                                    name="notification_for"
                                                    onChange={(e)=>this.handleChange(e)}
                                                >
                                                    <option value="all">All</option>
                                                    <option value="User">User</option>
                                                    <option value="Shopkeeper">Shopkeeper</option>
                                                </select>

                                                <span className="my-error">

                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-3">
                                                <label>{siteConstants.GEN_MESSAGE}</label>
                                            </div>
                                            <div className="col-lg-9">
                                                <textarea
                                                    className="form-control"
                                                    name="notification_message"
                                                    cols="57"
                                                    rows="10"
                                                    onChange={(e)=>this.handleChange(e)}
                                                    value={this.state.defaultData.notification_message}
                                                ></textarea>
                                                <span className="my-error">
                                                    {this.state.validated.errors.notification_message}
                                                </span>
                                            </div>
                                        </div>

                                    </CardContent>

                                    <CardActions>
                                        <div className="col-lg-3">
                                        </div>
                                        <div className="col-lg-9">
                                            <Button variant="contained" color="primary" onClick={(e) => this.emailNotifications(e)}>{siteConstants.BTN_SENT}</Button>
                                        </div>
                                    </CardActions>
                                </form>

                            </Card>

                            <br />
                        </div>
                        {/* <!-- /.container-fluid --> */}
                    </div>
                    {/* <!-- End of Main Content --> */}
                    <Footer />
                </div>
            </div>
        );
    }
}
//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, sentUserEmailNotifications } = state;
    return {
        language,
        sentUserEmailNotifications
    };
}

const connectedEmailNotifications = connect(mapStateToProps)(withStyles(styles)(EmailNotifications));
export { connectedEmailNotifications as EmailNotifications };
